import { Sparkles } from 'lucide-react';

import { ErrorState } from '@/components/ui/ErrorState';
import { Spinner } from '@/components/ui/Spinner';
import { EnrichmentList } from '@/features/catalog/components/EnrichmentList';
import { useEnrichments, useReviewEnrichment } from '@/features/catalog/hooks';
import type { ApiError } from '@/lib/errors';

export function EnrichmentReviewPage(): JSX.Element {
  const enrichments = useEnrichments({ status: 'pending' });
  const review = useReviewEnrichment();

  const count = enrichments.data?.length ?? 0;

  return (
    <section className="rounded-xl border border-ink-200/70 dark:border-white/10 bg-white dark:bg-ink-900 shadow-soft animate-slide-up">
      <header className="flex items-start justify-between gap-4 border-b border-ink-100 dark:border-white/5 px-6 py-4">
        <div className="flex items-start gap-3">
          <div className="flex h-9 w-9 items-center justify-center rounded-lg bg-gradient-to-br from-brand-400 to-brand-700 text-white shadow-glow">
            <Sparkles className="h-4 w-4" />
          </div>
          <div>
            <h3 className="h-section">Pending enrichments</h3>
            <p className="mt-1 text-xs text-ink-500 dark:text-ink-400">
              Approve to write back to OpenMetadata, or reject to discard.
            </p>
          </div>
        </div>
        {enrichments.data && (
          <span className="rounded-full bg-accent-amber/10 px-2.5 py-0.5 font-mono text-[10px] font-semibold tracking-[0.08em] text-accent-amber ring-1 ring-inset ring-accent-amber/30">
            {count} OPEN
          </span>
        )}
      </header>
      <div className="p-6">
        {enrichments.isPending ? (
          <Spinner />
        ) : enrichments.isError ? (
          <ErrorState error={enrichments.error as ApiError} />
        ) : (
          <EnrichmentList
            enrichments={enrichments.data}
            busyId={review.isPending ? review.variables.id : null}
            onApprove={(id) => review.mutate({ id, action: 'approve' })}
            onReject={(id) => review.mutate({ id, action: 'reject' })}
          />
        )}
      </div>
    </section>
  );
}
